module.exports = {
    "Clear search": `\u{15E}terge\u{163}i c\u{103}utarea`
};


//# sourceMappingURL=ro-RO.main.js.map
